<template>
  <v-dialog v-model="mostrarDialogoBaixarDocumento" persistent :max-width="500">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        <span class="headline">{{ multiplo ? 'Baixar Documentos Selecionados' : 'Baixar Documento' }}</span>
        <v-spacer/>
        <v-icon @click="fecharModal" color="white">close</v-icon>
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div class="az-text mb-3">
          <p v-if="multiplo"><strong>Selecione o tipo de download para os documentos selecionados:</strong></p>
          <p v-else><strong>Selecione o tipo de documento que deseja baixar</strong></p>
        </div>
      </v-card-text>
      <v-card-actions class="acoes justify-center">
        <v-btn class="botao-opcao-download px-1" color="#777" flat @click="baixarOriginal()">
          Original
        </v-btn>
        <v-btn class="botao-opcao-download px-1" color="#777" flat @click="baixarAssinado()">
          Assinado
        </v-btn>
        <v-btn class="botao-opcao-download px-1" flat @click="baixarImpressao()">
          Impressão
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalConfirmarBaixarDocumento',
  props: {
    mostrarDialogoBaixarDocumento: {
      type: Boolean,
      default: false
    },
    multiplo: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    baixarOriginal(){
      this.$emit('confirmar', 'ORIGINAL')
    },
    baixarImpressao(){
      this.$emit('confirmar', 'IMPRESSAO')
    },
    baixarAssinado(){
      this.$emit('confirmar', 'ASSINADO')
    },
    fecharModal() {
      this.$emit('fechar')
    },
  }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 600

.botao-opcao-download
  padding 0 15px
  border 1px solid #0067a5
  background-color #0067a5 !important
  color #fff !important
  box-sizing border-box

.acoes
  padding 20px 0 !important
</style>